import React from 'react';

import '../../Style/Loading.css'



export default function Loading() {
    return (
        <div>
            <div className='spinner'></div>
            <p>cargando...</p>

        </div>
    )
}